export default __webpack_public_path__ + "static/unpollo-1dcdec87b4fd0226ba80b7cd02919e8a.jpg";